<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="vm.isDesktop ? 'background-alternative' : 'background'"
    [themeFlush]="vm.isDesktop"
  >
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [lg]="2" />
        <dgx-components-grid-column
          [dgxTheme]="'background'"
          [lg]="8"
          [ngClass]="{
            'protection-details-page__content--desktop': vm.isDesktop
          }"
          [xs]="12"
        >
          <ng-container *ngIf="vm.showWasherEnhancement">
            <!-- Enhanced Washer UI: Images, Extra Content -->
            <dgx-components-grid-row>
              <dgx-components-grid-column [md]="12">
                <dgx-components-grid-column [xs]="12">
                  <dgx-components-promotional-banner
                    *ngIf="vm.promotionalPriceEnabled"
                    [iconSize]="'xl'"
                    [rounded]="true"
                    [title]="
                    vm.displayPromotionalBannerTextVariant ?
                      ('PROTECTION_DETAILS_ACH_PROMOTIONAL_OFFERS_TITLE'
                      | translate)
                    :
                  ('PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE'
                      | translate
                        : {
                            discountedMonthPercentage:
                              vm.registeredItemProductDetails?.discountDetails
                                ?.discountedMonthPercentage,
                            discountedMonthsCount:
                              vm.registeredItemProductDetails?.discountDetails
                                ?.discountedMonthsCount,
                          })
                  "
                    class="protection-details-page__promotional-banner pb-5"
                  />

                  <h1 class="protection-details-page__title">
                    {{ vm.washerApplianceContent.title }}
                  </h1>
                </dgx-components-grid-column>
              </dgx-components-grid-column>
            </dgx-components-grid-row>
            <dgx-components-grid-row
              class="protection-details-page__subtitle mb-4"
            >
              <dgx-components-grid-column [md]="12" class="flex-image-wrapper">
                <p
                  *ngIf="vm.washerApplianceContent?.subtitle"
                  [innerHTML]="
                    'PROTECTION_DETAILS_WASHER_SUBTITLE'
                      | translate
                        : {
                            brandName: vm.registeredItem?.merchandiseBrand || ''
                          }
                  "
                  class="text-base my-6"
                ></p>
                <div class="image-flex-center">
                  <img
                    alt="Enhanced Washer Coverage Image 1"
                    class="washer-image"
                    src="assets/images/washer-image-1.png"
                  />
                  <img
                    alt="Enhanced Washer Coverage Image 2"
                    class="washer-image"
                    src="assets/images/washing-machine.png"
                  />
                </div>
              </dgx-components-grid-column>
            </dgx-components-grid-row>

            <dgx-components-grid-row>
              <dgx-components-grid-column [md]="12">
                <dgx-components-grid-column [xs]="12">
                  <dgx-components-rich-text
                    [content]="vm.washerApplianceContent.caption"
                    class="protection-details-page__subtitle my-6"
                  />
                </dgx-components-grid-column>
              </dgx-components-grid-column>
            </dgx-components-grid-row>
          </ng-container>
          <ng-container *ngIf="!vm.showWasherEnhancement">
            <dgx-components-grid-row>
              <dgx-components-grid-column [md]="12">
                <dgx-components-grid-column [xs]="12">
                  <dgx-components-promotional-banner
                    *ngIf="vm.promotionalPriceEnabled"
                    [iconSize]="'xl'"
                    [rounded]="true"
                    [title]="
                     vm.displayPromotionalBannerTextVariant ?
                      ('PROTECTION_DETAILS_ACH_PROMOTIONAL_OFFERS_TITLE'
                      | translate)
                    :
                  ('PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE'
                      | translate
                        : {
                            discountedMonthPercentage:
                              vm.registeredItemProductDetails?.discountDetails
                                ?.discountedMonthPercentage,
                            discountedMonthsCount:
                              vm.registeredItemProductDetails?.discountDetails
                                ?.discountedMonthsCount,
                          })
                  "
                    class="protection-details-page__promotional-banner pb-5"
                  />

                  <h1 class="protection-details-page__title">
                    {{ vm.cmsData.protectionDetailsPageTitle }}
                  </h1>
                </dgx-components-grid-column>
              </dgx-components-grid-column>
            </dgx-components-grid-row>

            <dgx-components-grid-row>
              <dgx-components-grid-column [md]="12">
                <dgx-components-grid-column [xs]="12">
                  <dgx-components-rich-text
                    [content]="vm.cmsData.protectionDetailsBannerContent"
                    class="protection-details-page__subtitle my-6"
                  />
                </dgx-components-grid-column>
              </dgx-components-grid-column>
            </dgx-components-grid-row>
          </ng-container>

          <dgx-components-grid-row class="protection-details__accordion pt-5">
            <dgx-components-grid-column>
              <us-registration-protection-benefits-accordion
                *ngIf="vm.showWasherEnhancement"
                [isDesktop]="vm.isDesktop"
                [panels]="vm.washerApplianceContent.accordion"
              />
              <us-registration-protection-benefits-accordion
                *ngIf="!vm.showWasherEnhancement"
                [isDesktop]="vm.isDesktop"
                [panels]="vm.cmsData.accordionPanels"
              />
              <us-registration-warranty-note-panel [spacingClass]="'mt-5'" />
            </dgx-components-grid-column>
          </dgx-components-grid-row>

          <div [ngSwitch]="vm.prepaySubscriptionVariant">
            <ng-container *ngIf="vm.registeredItemHasAnnualPayment">
              <ng-container *ngSwitchCase="prepaySubscriptionVariant.One">
                <!-- Variant 1 -->
                <dgx-components-grid-row>
                  <dgx-components-grid-column>
                    <dgx-components-panel
                      [border]="true"
                      [rounded]="'lg'"
                      [spacing]="'sm'"
                      [variant]="'dg-primary-alternative-light'"
                      class="pt-4 mb-5"
                    >
                      <us-registration-terms-and-conditions
                        [termsAndConditions]="
                          vm.cmsData.protectionDetailsTermsAndConditions
                        "
                        class="protection-details-page__terms-and-conditions"
                      />
                    </dgx-components-panel>
                  </dgx-components-grid-column>
                </dgx-components-grid-row>

                <p class="protection-details-page__choose-payment-method py-3">
                  {{ 'PROTECTION_DETAILS_CHOOSE_PAYMENT_METHOD' | translate }}
                </p>

                <dgx-components-grid-row>
                  <dgx-components-grid-column
                    *ngFor="let item of vm.registeredItem?.products"
                    [md]="6"
                    class="protection-details-page__purchase-price-option-column"
                  >
                    <us-registration-protection-details-purchase-price-option
                      (buttonClicked)="cs.handlePaymentOptionAction($event)"
                      [badgeText]="
                        item.paymentFrequency === 'monthly'
                          ? ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY'
                            | translate
                              : {
                                  discountedMonthPercentage:
                                    item.discountDetails
                                      ?.discountedMonthPercentage,
                                  discountedMonthsCount:
                                    item.discountDetails?.discountedMonthsCount
                                })
                          : ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY'
                            | translate
                              : {
                                  discountedMonthPercentage:
                                    item.discountDetails
                                      ?.discountedMonthPercentage,
                                  discountedMonthsCount:
                                    item.discountDetails?.discountedMonthsCount
                                })
                      "
                      [buttonText]="
                        'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA'
                          | translate
                            : {
                                monthlyOrAnnual:
                                  item | registeredItemMonthlyOrAnnuallyLabel
                              }
                      "
                      [disclaimer]="
                        'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_DISCLAIMER'
                          | translate
                      "
                      [discountedPrice]="
                        item.discountDetails?.discountedPrice | currencyFormat
                      "
                      [newMessage]="
                        'PROTECTION_DETAILS_NEW_MESSAGE' | translate
                      "
                      [originalPrice]="item.price | currencyFormat"
                      [paymentFrequency]="item.paymentFrequency"
                      [promotionalPriceEnabled]="vm.promotionalPriceEnabled"
                      [subtitle]="
                        item.paymentFrequency === 'monthly'
                          ? ('PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY'
                            | translate)
                          : ('PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL'
                            | translate)
                      "
                    />
                  </dgx-components-grid-column>
                </dgx-components-grid-row>
                <dgx-components-grid-row class="mt-3">
                  <dgx-components-grid-column [md]="12">
                    <div
                      class="protection-details__register-only-cta-container"
                    >
                      <dgx-components-button-text
                        (clicked)="cs.triggerRegistrationUpsellModal()"
                        [dgxGaClick]="{
                        pagename: 'protection-details',
                        applianceName: vm.registeredItem?.appliances?.[0]?.type,
                        brand: vm.registeredItem?.merchandiseBrand,
                        eventCategory: 'applianceCover',
                        eventAction: 'coverType',
                        eventLabel: 'Register only'
                        }"
                        [underline]="true"
                        [underlineNeutral]="true"
                        class="mt-3"
                      >
                        {{
                          'PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA'
                            | translate
                        }}
                      </dgx-components-button-text>
                    </div>
                  </dgx-components-grid-column>
                </dgx-components-grid-row>

                <dgx-components-grid-row
                  class="mt-3 protection-details__border-divider"
                >
                  <dgx-components-grid-column [md]="12">
                    <us-registration-protection-details-accordion-panel
                      [panels]="vm.cmsData.accordionCancelPanels"
                    />
                  </dgx-components-grid-column>
                </dgx-components-grid-row>
              </ng-container>

              <ng-container *ngSwitchCase="prepaySubscriptionVariant.Two">
                <!-- Variant 2 -->
                <dgx-components-grid-row>
                  <dgx-components-grid-column [md]="6">
                    <dgx-components-grid-column [xs]="12">
                      <dgx-components-panel
                        [border]="false"
                        [rounded]="'lg'"
                        [spacing]="'sm'"
                        [variant]="'dg-primary-alternative-light'"
                        class="pt-4"
                      >
                        <us-registration-terms-and-conditions
                          [termsAndConditions]="
                            vm.cmsData.protectionDetailsTermsAndConditions
                          "
                          class="protection-details-page__terms-and-conditions"
                        />
                      </dgx-components-panel>
                    </dgx-components-grid-column>
                  </dgx-components-grid-column>

                  <dgx-components-grid-column [md]="6">
                    <dgx-components-grid-column [xs]="12">
                      <us-registration-protection-details-quote-offer
                        [discountedMonthPercentage]="
                          vm.registeredItemProductDetails?.discountDetails
                            ?.discountedMonthPercentage
                        "
                        [discountedMonthsCount]="
                          vm.registeredItemProductDetails?.discountDetails
                            ?.discountedMonthsCount
                        "
                        [promotionActive]="vm.promotionalPriceEnabled"
                        [quoteBrand]="vm.registeredItem?.merchandiseBrand"
                        [quoteOriginalPrice]="
                          vm.registeredItemProductDetails?.price
                        "
                        class="protection-details-page__quote-offer pt-3"
                      />
                    </dgx-components-grid-column>
                  </dgx-components-grid-column>
                </dgx-components-grid-row>

                <div class="protection-details__ctas-container">
                  <div class="protection-details__ctas">
                    <dgx-components-button
                      (click)="cs.continueToOrderConfirmation()"
                      [dgxGaClick]="{
                        pagename: 'protection-details',
                        applianceName: vm.registeredItem?.appliances?.[0]?.type,
                        brand: vm.registeredItem?.merchandiseBrand,
                        eventCategory: 'applianceCover',
                        eventAction: 'coverType',
                        eventLabel: 'Register with extra coverage'
                      }"
                      [fill]="true"
                      [variant]="'primary'"
                      class="my-4 protection-details__cta"
                    >
                      {{
                        'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE'
                          | translate
                      }}
                    </dgx-components-button>
                    <dgx-components-button
                      (click)="cs.triggerRegistrationUpsellModal()"
                      [dgxGaClick]="{
                        pagename: 'protection-details',
                        applianceName: vm.registeredItem?.appliances?.[0]?.type,
                        brand: vm.registeredItem?.merchandiseBrand,
                        eventCategory: 'applianceCover',
                        eventAction: 'coverType',
                        eventLabel: 'Register only'
                      }"
                      [fill]="true"
                      [variant]="'secondary'"
                      class="protection-details__cta"
                    >
                      {{
                        'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE'
                          | translate
                      }}
                    </dgx-components-button>
                  </div>
                </div>

                <dgx-components-grid-row
                  class="mt-3 protection-details__border-divider"
                >
                  <dgx-components-grid-column [md]="12">
                    <us-registration-protection-details-accordion-panel
                      [panels]="vm.cmsData.accordionCancelPanels"
                    />
                  </dgx-components-grid-column>
                </dgx-components-grid-row>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <!-- Control variant -->
              <dgx-components-grid-row>
                <dgx-components-grid-column [md]="6">
                  <dgx-components-grid-column>
                    <dgx-components-panel
                      [border]="false"
                      [rounded]="'lg'"
                      [spacing]="'sm'"
                      [variant]="'dg-primary-alternative-light'"
                      class="pt-4"
                    >
                      <us-registration-terms-and-conditions
                        [termsAndConditions]="
                          vm.cmsData.protectionDetailsTermsAndConditions
                        "
                        class="protection-details-page__terms-and-conditions"
                      />
                    </dgx-components-panel>
                  </dgx-components-grid-column>
                </dgx-components-grid-column>

                <dgx-components-grid-column [md]="6">
                  <dgx-components-grid-column>
                    <us-registration-protection-details-quote-offer
                      [discountedMonthPercentage]="
                        vm.registeredItemProductDetails?.discountDetails
                          ?.discountedMonthPercentage
                      "
                      [discountedMonthsCount]="
                        vm.registeredItemProductDetails?.discountDetails
                          ?.discountedMonthsCount
                      "
                      [promotionActive]="vm.promotionalPriceEnabled"
                      [quoteBrand]="vm.registeredItem?.merchandiseBrand"
                      [quoteOriginalPrice]="
                        vm.registeredItemProductDetails?.price
                      "
                    />
                  </dgx-components-grid-column>
                </dgx-components-grid-column>
              </dgx-components-grid-row>

              <div class="protection-details__ctas-container">
                <div class="protection-details__ctas">
                  <dgx-components-button
                    (click)="cs.continueToOrderConfirmation()"
                    [dgxGaClick]="{
                      pagename: 'protection-details',
                      applianceName: vm.registeredItem?.appliances?.[0]?.type,
                      brand: vm.registeredItem?.merchandiseBrand,
                      eventCategory: 'applianceCover',
                      eventAction: 'coverType',
                      eventLabel: 'Register with extra coverage'
                    }"
                    [fill]="true"
                    [variant]="'primary'"
                    class="my-4 protection-details__cta"
                  >
                    {{
                      'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITH_COVER_TITLE'
                        | translate
                    }}
                  </dgx-components-button>
                  <dgx-components-button
                    (click)="cs.triggerRegistrationUpsellModal()"
                    [dgxGaClick]="{
                      pagename: 'protection-details',
                      applianceName: vm.registeredItem?.appliances?.[0]?.type,
                      brand: vm.registeredItem?.merchandiseBrand,
                      eventCategory: 'applianceCover',
                      eventAction: 'coverType',
                      eventLabel: 'Register only'
                    }"
                    [fill]="true"
                    [variant]="'secondary'"
                    class="protection-details__cta"
                  >
                    {{
                      'PROTECTION_DETAILS_SINGLE_REGISTRATION_WITHOUT_COVER_TITLE'
                        | translate
                    }}
                  </dgx-components-button>
                </div>
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="vm.showWasherEnhancement">
            <dgx-components-grid-row>
              <dgx-components-grid-column [md]="12">
                <dgx-components-grid-column [xs]="12">
                  <dgx-components-rich-text
                    [content]="vm.washerApplianceContent.footerDisclaimer"
                    class="protection-details-page__terms-and-conditions"
                  />
                </dgx-components-grid-column>
              </dgx-components-grid-column>
            </dgx-components-grid-row>
          </ng-container>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <dgx-components-loading-overlay
    *ngIf="vm.ctaUpsellLoading"
    [loader]="vm.ctaUpsellLoading"
  />
</ng-container>

<div [content]="main" editable-area></div>
